var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61861 16.2663C4.11027 16.2663 3.63528 16.0913 3.29361 15.7663C2.86028 15.358 2.65194 14.7413 2.72694 14.0746L3.03528 11.3746C3.09361 10.8663 3.40194 10.1913 3.76028 9.82463L10.6019 2.58296C12.3103 0.774624 14.0936 0.724624 15.9019 2.43296C17.7103 4.14129 17.7603 5.92462 16.0519 7.73296L9.21027 14.9746C8.86027 15.3496 8.21027 15.6996 7.70194 15.783L5.01861 16.2413C4.87694 16.2496 4.75194 16.2663 4.61861 16.2663ZM13.2769 2.42462C12.6353 2.42462 12.0769 2.82462 11.5103 3.42462L4.66861 10.6746C4.50194 10.8496 4.31028 11.2663 4.27694 11.508L3.96861 14.208C3.93528 14.483 4.00194 14.708 4.15194 14.8496C4.30194 14.9913 4.52694 15.0413 4.80194 14.9996L7.48527 14.5413C7.72694 14.4996 8.12694 14.283 8.29361 14.108L15.1353 6.86629C16.1686 5.76629 16.5436 4.74962 15.0353 3.33296C14.3686 2.69129 13.7936 2.42462 13.2769 2.42462Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4507 9.12568C14.434 9.12568 14.409 9.12568 14.3924 9.12568C11.7924 8.86734 9.70069 6.89234 9.30069 4.30901C9.25069 3.96734 9.48402 3.65068 9.82569 3.59234C10.1674 3.54234 10.484 3.77568 10.5424 4.11734C10.859 6.13401 12.4924 7.68401 14.5257 7.88401C14.8674 7.91735 15.1174 8.22568 15.084 8.56734C15.0424 8.88401 14.7674 9.12568 14.4507 9.12568Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.9583H2.5C2.15833 18.9583 1.875 18.675 1.875 18.3333C1.875 17.9917 2.15833 17.7083 2.5 17.7083H17.5C17.8417 17.7083 18.125 17.9917 18.125 18.3333C18.125 18.675 17.8417 18.9583 17.5 18.9583Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutline);
export default __webpack_public_path__ + "static/media/edit-outline.864f7a577ad8ed7329f60b531f665e86.svg";
export { ForwardRef as ReactComponent };